// extracted by css-extract-rspack-plugin
export default {"title":"_66f171a3","listWrapper":"_fa9c9cd2"};